<template>
   <b-button
      @click="() => { modalState = true }"
      size="sm"
      :disabled="disabled"
      :variant="(httpRequestInProgress) ? 'success': 'primary'"
      block
   ><!-- button -->
      <span v-if="httpRequestInProgress">
      <b-spinner
         type="grow"
         label="Loading..."
         small
      ></b-spinner>
      </span>
      <span v-else>Bestellungserfüllung zurückziehen</span>
      <b-modal id="modal-unfreeze-order"
         v-model="modalState"            
         title="Bestellungserfüllung zurückziehen"
         @ok="submit()"
         cancel-title="abbrechen"
         size="md"
      ><!-- modal -->
         {{messagePrompt}}
      </b-modal>
   </b-button>
</template>
<script>
export default {
   props: ['customerOrderItemDelivery', 'customerOrderId', 'messagePrompt', 'orderStates', 'authorization' ]
   , data() {
      return {
         modalState: false,
         httpRequestInProgress: false,
         noSubmissionTime: false
      };
   }
   , computed: {
      disabled: function() {
         // "Alles über Mailer/Support – Berechtigungsseite Accountmanager" => interpretation: „Ab mailer_manager“ 
         // disable if user isn't at least mailer manager.
         console.log("COU-CDS: func disabled");
         if(!this.authorization.mailer_manager) return true;
         console.log("COU-CDS: Auth OK");
         if(this.httpRequestInProgress) return true;
         console.log("COU-CDS: No REQ running");
         if(!this.customerOrderItemDelivery) return true;
         console.log("COU-CDS: Delivery OK");
         if(this.customerOrderItemDelivery.deliverySubmissionTime) return true;
         console.log("COU-CDS: Delivery Time OK");
         return false; 
      }
   }
   , methods: {
      submit() {
         let payload = {
            customerOrderItemDeliveryId: this.customerOrderItemDelivery.id,
            customerOrderId: this.customerOrderId
         }
         this.httpRequestInProgress = true;
         Promise.all([
            axios.post('/customerorder/action/canceldeliverysubmission', payload),
            new Promise(r => setTimeout(r, 750))
         ]).then( response => {
            this.httpRequestInProgress = false;
            this.customerOrderItemDelivery = response.data;
            this.$emit('mutatedCustomerOrderItemDelivery', response.data);
         }).catch( error => {
            alert("Ein Fehler ist aufgetreten. Bitte den Devs melden.");
            this.httpRequestInProgress = false;
            console.error(error);
         });
      }
   }
}
</script>
